<script lang="ts">
  /* eslint-disable @typescript-eslint/no-unsafe-assignment */
  import { BehaviorSubject, catchError, exhaustMap, fromEvent, of, tap, withLatestFrom } from 'rxjs'
  import { sendEventToFirebase } from '../logging/events'
  import CtaButton from '../Generic/CtaButton.svelte'
  import { organization, app_user } from '../Users/observables'
  import { CreateCheckoutSession } from '../utilities/backendApi'
  import { SupportEmail } from '../utilities/Constants'
  import { onMount } from 'svelte'
  type RequestState =
    | { state: 'Init' }
    | { state: 'Loading' }
    | { state: 'Done'; message: string }
    | { state: string; message: string }
  const requestStatus = new BehaviorSubject<RequestState>({ state: 'Init' })
  let button: HTMLButtonElement

  onMount(() => {
    const request = fromEvent(button, 'click').pipe(
      withLatestFrom(organization),
      tap(() => requestStatus.next({ state: 'Loading' })),
      exhaustMap(([_, organization]) => {
        return (async (): Promise<RequestState> => {
          const id = (organization as { [x: string]: any }).uid
          const response = await CreateCheckoutSession({ type: 'existing', id })
          if (response.status == 'Ok') {
            sendEventToFirebase({ key: 'LapsedSubscriptionStartedCheckout', organization: id })
            window.location.href = response.url
            return { state: 'Done', message: 'Redirecting to Stripe now.' }
          }
          return { state: 'Done', message: response.message }
        })()
      }),
      catchError(() =>
        of({
          state: 'Done',
          message: `Something has gone wrong. Send a mail to ${SupportEmail} and we will get it fixed.`,
        }),
      ),
    )
    const sub = request.subscribe(requestStatus)
    return () => sub.unsubscribe()
  })
</script>

{#if $app_user.state === 'LapsedSubscription' && $app_user.role === 'Admin'}
  <p>
    Your subscription lapsed. If you wish to continue using the app, click the button below to visit Stripe
    and update your payment information.
  </p>
  <CtaButton bind:inner={button} disabled={$requestStatus.state === 'Loading'}>
    Enter Payment Information</CtaButton
  >
  {#if $requestStatus.state === 'Done'}
    <h2>{$requestStatus.message}</h2>
  {/if}
{:else}
  <p>
    Your subscription has lapsed. Contact your admin to update the payment details in order to keep using the
    app.
  </p>
{/if}
